import { Dropdown } from "primereact/dropdown";
import { useAssignAsset } from "../../Hooks/Features/InventoryDashboard/useAssignAsset"
import { MultiSelect } from "primereact/multiselect";
import CommonImage from "../CommonCompo/CommonImage/CommonImage";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import AssetAllocationPDF from "./AssetAllocationPDF";
import _ from "underscore";

const AssignAssetForm = ({ onClose, editData, gridData, dropdownOpts, handleAssetDetails, filterValues }) => {

    const { fieldValues, setFieldValues, options, handleReset, handleAssign, loader, allocationFormRef } = useAssignAsset({ onClose, editData, gridData, dropdownOpts, handleAssetDetails, filterValues });

    return (
        <div className="d-flex flex-wrap gap-2">
            <div className="w50">
                <div>Assign To*</div>
                <Dropdown className="input-dd" options={options?.assign_to} value={fieldValues?.assign_to} onChange={(e) => setFieldValues((prev) => ({ ...prev, assign_to: e.target.value }))} filter filterInputAutoFocus optionLabel="user_display_name" />
            </div>
            <div className="w45">
                <div>Assign Date*</div>
                <Calendar className="input-dd inventory-assign-calendar" value={fieldValues?.assign_date} onChange={(e) => setFieldValues((prev) => ({ ...prev, assign_date: e.target.value }))} dateFormat="dd-mm-yy" />
            </div>
            <div className="w100">
                <div>Assign Other Assets?</div>
                <MultiSelect className="inventory-multiselect disable" style={{ height: "auto" }} display="chip" options={options?.assets_details} value={fieldValues?.other_assets} onChange={(e) => setFieldValues((prev) => ({ ...prev, other_assets: e.target.value }))} filter filterInputAutoFocus optionLabel="asset_unique_id" optionValue="asset_id" optionDisabled={(option) => fieldValues?.disable_assigned?.includes(option?.asset_id)} />
            </div>
            <div className="w100">
                <div>Assign Remark*</div>
                <input type="text" className="input-dd w100" value={fieldValues?.remark} onChange={(e) => setFieldValues((prev) => ({ ...prev, remark: e.target.value }))} />
            </div>
            <div className="w100">
                <div>Upload Media of <span className="fw-bold">{editData?.asset_unique_id}</span></div>
                <CommonImage type="upload" selectedImages={fieldValues?.media} setSelectedImages={(val) => setFieldValues((prev) => ({ ...prev, media: val }))} />
            </div>
            {fieldValues?.other_assets?.length > 0 && fieldValues?.other_assets?.map((asset, index) => (
                <div className="w100" key={index}>
                    <div>Upload Media for <span className="fw-bold">{options?.all_assets?.[asset]}</span></div>
                    <CommonImage type="upload" selectedImages={fieldValues?.[options?.all_assets?.[asset]] || []} setSelectedImages={(val) => setFieldValues((prev) => ({ ...prev, [options?.all_assets?.[asset]]: val }))} />
                </div>
            ))}
            <div className={`d-flex justify-content-${!_.isEmpty(fieldValues?.assign_to) ? "between" : "end"} align-items-center w100`}>
                {!_.isEmpty(fieldValues?.assign_to) && <div className="text-primary c-pointer" onClick={() => setFieldValues((prev) => ({ ...prev, asset_allocation_form: true }))}>View Asset Allocation Form</div>}
                <div>
                    <button className="button btn-default" onClick={() => { onClose(); handleReset(); }}>Cancel</button>
                    {loader ?
                        <button className="button btn-primary" style={{ width: "70px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                        <button className="button btn-primary" style={{ width: "70px" }} onClick={() => { handleAssign() }}>Assign</button>
                    }
                </div>
            </div>

            <div className="asset-allocation-pdf">
                <div ref={allocationFormRef} className="px-5"><AssetAllocationPDF editData={editData} assignValues={fieldValues} options={{ ...options, ...dropdownOpts }} /></div>
            </div>

            <Dialog className="modal-medium h-100" style={{ width: "35%", maxWidth: "35%" }} draggable={false} visible={fieldValues?.asset_allocation_form} onHide={() => setFieldValues((prev) => ({ ...prev, asset_allocation_form: false }))} header="Asset Allocation Form">
                <div><AssetAllocationPDF editData={editData} assignValues={fieldValues} options={{ ...options, ...dropdownOpts }} /></div>
            </Dialog>
        </div>
    )
}

export default AssignAssetForm